const FlagUK = props => (
	<svg height="28" viewBox="0 0 200 200" width="28" {...props}>
		<rect fill="#4758a9" width="200" height="200" />
		<rect fill="#fff" x="85" y="-92.68" width="30" height="385.35" transform="translate(100 -41.42) rotate(45)" />
		<rect
			fill="#ed5565"
			x="-84.18"
			y="92.53"
			width="362"
			height="10"
			transform="translate(234.24 98.03) rotate(135)"
		/>
		<rect fill="#fff" x="85" y="-92.68" width="30" height="385.35" transform="translate(-41.42 100) rotate(-45)" />
		<rect
			fill="#ed5565"
			x="-83.47"
			y="98.18"
			width="362"
			height="10"
			transform="translate(101.53 -38.74) rotate(45)"
		/>
		<rect fill="#fff" x="75" y="-10.74" width="50" height="221.48" />
		<rect fill="#fff" x="75" y="-10.74" width="50" height="221.48" transform="translate(200 0) rotate(90)" />
		<rect fill="#ed5565" x="-4" y="85" width="208" height="30" transform="translate(200) rotate(90)" />
		<rect fill="#ed5565" x="-4" y="85" width="208" height="30" transform="translate(200 200) rotate(180)" />
	</svg>
);

export default FlagUK;
